<template>
	<div :class="[`validationText ${addClass}`, {'alert': status}]">
		<slot></slot>
		<p v-show="status" class="alertText">
			{{text}}
		</p>
	</div>
</template>

<script>
export default {
	props: {
		addClass: {
			type: String,
			default(){return ''},
		},
		text: {
			type: String,
			default(){return '필수 입력값입니다.'}
		},
		status: {
			type: Boolean,
			default(){return false}
		}
	},
	data() {
		return {}
	}
}
</script>

<style lang="scss" scoped>
.validationText {
	&.alert {
		input, textarea {
			border-color : #F64E4E !important
		}
	}
	p.alertText {
		display: flex;
		margin: 8px 0 0 0;
		@include text-prt-sb;
		&::before {
			content: '';
			display: inline-block;
			width: 13px; height: 13px;
			margin: -1px 5px 0 0;
			background: url('../../../assets/icons/icon-alert.svg') center no-repeat;
		}
		font-size: 12px;
		color:#F64E4E
	}
}

</style>